export default __webpack_public_path__ + "static/media/electrical.d3b96bcb.svg";